import { Controller } from "@hotwired/stimulus"

// Owns the purchase panel's Turbo-Stream-replace papercuts, mirroring
// budget_commitment_controller.js (KT-834 review):
// - a formatted-currency echo of the amount field (the field is dollars
//   already; server-side validation, not this preview, is the guard against a
//   malformed amount -- see BudgetPurchaseForm / Budgets::RecordPurchase)
// - a derived $/hour echo, labelled an estimate (FR-014, ADR-006: rates are
//   always derived, never looked up from a stored price list). The
//   authoritative per-entry figure is BudgetEntry#effective_rate_cents_per_hour,
//   computed server-side after the write.
// - restoring focus to the panel after a purchase submit, since
//   turbo_stream.replace swaps the whole panel (including the just-clicked
//   submit button), which otherwise resets focus to <body>
//
// Pure enhancement: both fields and the form work with JS off.
export default class extends Controller {
  static targets = ["hoursField", "amountField", "amountPreview", "ratePreview"]
  static values = { justSubmitted: Boolean }

  connect() {
    // Only refocus when this panel was just re-rendered by the purchase
    // turbo-stream response (see create.turbo_stream.erb) -- an ordinary
    // page load/connect should never steal focus from the top of the page.
    if (this.justSubmittedValue) {
      this.element.focus()
    }

    this.previewRate()
  }

  previewRate() {
    const dollars = this.fieldValue(this.hasAmountFieldTarget && this.amountFieldTarget)
    const hours = this.fieldValue(this.hasHoursFieldTarget && this.hoursFieldTarget)

    if (this.hasAmountPreviewTarget) {
      this.amountPreviewTarget.textContent = dollars === null ? "" : `= ${this.currency(dollars)}`
    }

    if (!this.hasRatePreviewTarget) return

    this.ratePreviewTarget.textContent =
      dollars === null || hours === null || hours === 0
        ? ""
        : `≈ ${this.currency(dollars / hours)} per hour (estimate)`
  }

  fieldValue(field) {
    if (!field) return null

    const parsed = parseFloat(field.value)
    return Number.isNaN(parsed) ? null : parsed
  }

  currency(amount) {
    return amount.toLocaleString("en-US", { style: "currency", currency: "USD" })
  }
}
